import type { Theme } from '@mui/material/styles';

export const MuiTextField = {
  styleOverrides: {
    root: ({ theme }: { theme: Theme }) => ({
      '& .MuiOutlinedInput-root': {
        fontSize: '14px',
        color: theme.palette.custom.textMain,
        fontWeight: 600,
        height: '40px',
        borderRadius: '8px',
        '& fieldset': {
          borderColor: theme.palette.custom.lightGrayBrown,
        },
        '&:hover fieldset': {
          borderColor: theme.palette.custom.lightGrayBrown,
        },
        '&.Mui-focused fieldset': {
          borderColor: theme.palette.custom.lightGrayBrown,
        },
        '& .MuiOutlinedInput-input': {
          padding: '0 12px',
        },
      },
      '& .MuiOutlinedInput-input::placeholder': {
        fontSize: '14px',
        fontFamily: 'Manrope Variable, Arial, sans-serif',
        color: theme.palette.custom.lightBrown,
      },
    }),
  },
};

export const MuiSelect = {
  styleOverrides: {
    root: ({ theme }: { theme: Theme }) => ({
      height: '40px',
      borderRadius: '8px',
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.custom.lightGrayBrown,
      },
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.custom.lightGrayBrown,
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.custom.lightGrayBrown,
      },
      '& .MuiSelect-select': {
        display: 'flex',
        alignItems: 'center',
        padding: '0 12px',
      },
    }),
  },
};

export const formComponents = {
  MuiTextField,
  MuiSelect,
};
